import { SVGProps } from "react";

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      width="1em"
      height="1em"
      viewBox="0 0 16 16"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(1.000000, 1.000000)">
          <g transform="translate(7.000000, 7.000000) rotate(-45.000000) translate(-7.000000, -7.000000) ">
            <g transform="translate(7.291667, 7.291667) rotate(-180.000000) translate(-7.291667, -7.291667) translate(2.333333, 2.333333)">
              <g transform="translate(0.000000, -0.000000)">
                <g transform="translate(0.000000, -0.000000)">
                  <g
                    fill="currentColor"
                    fillRule="nonzero"
                    transform="translate(5.028996, 5.028439) rotate(-45.000000) translate(-5.028996, -5.028439)"
                  >
                    <path d="M1.87224558,1.97573126 C1.69443383,2.20447862 1.71059853,2.53556006 1.92073969,2.74570122 L4.20364583,5.02854507 L1.92073969,7.31138893 C1.69308677,7.53904185 1.69308677,7.90863163 1.92073969,8.13628455 C2.03165011,8.24719497 2.17993575,8.30687841 2.33347917,8.30687841 L2.40937591,8.30193721 C2.53468246,8.28554382 2.65280902,8.22874641 2.74515831,8.13733946 L5.0290625,5.85337841 L7.31190636,8.13628455 C7.42281678,8.24719497 7.57110242,8.30687841 7.72464583,8.30687841 C7.87756741,8.30687841 8.02550583,8.2470278 8.13632497,8.13733946 L8.18504544,8.0821886 C8.36369117,7.85261153 8.34752647,7.52153008 8.13738531,7.31138893 L5.85447917,5.02854507 L8.13738531,2.74570122 C8.36481415,2.51710144 8.3640923,2.14751528 8.13569051,1.9202788 L8.08087758,1.87189715 C7.85254562,1.69449974 7.52146418,1.71066444 7.31132302,1.92080559 L5.02847917,4.20371174 L2.74563531,1.92080559 C2.51798239,1.69315268 2.14839261,1.69315268 1.92073969,1.92080559 L1.87224558,1.97573126 Z" />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}

export default SvgComponent;
